import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import DoneAll from "@mui/icons-material/DoneAll";
import PublishedWithChanges from '@mui/icons-material/PublishedWithChanges'
import CircularProgress from "@mui/material/CircularProgress";
import AgricultureIcon from '@mui/icons-material/Agriculture';
import { useState, useEffect } from "react";


import Table from "react-bootstrap/Table";
import styles from "./romaneios.module.css";

import toast from "react-hot-toast";

import { useSelector } from "react-redux";
import { selectIsAdminUser } from "../../../store/user/user.selector";

import beans from "../../../utils/assets/icons/beans2.png";
import soy from "../../../utils/assets/icons/soy.png";
import rice from "../../../utils/assets/icons/rice.png";
import cotton from '../../../utils/assets/icons/cotton.png'
import question from '../../../utils/assets/icons/question.png'
import corn from '../../../utils/assets/icons/corn.png'

import { nodeServerSrd } from "../../../utils/axios/axios.utils";

import Tooltip from '@mui/material/Tooltip';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import html2canvas from "html2canvas";
import { useRef, useCallback } from "react";


const RomaneiosTable = (props) => {
	const { data, handleUpdateCarga, setFilterDataArr, duplicates, duplicatesPlates, selected, selectedTicket } = props;
	console.log('data table: ', data)

	const theme = useTheme();
	const colors = tokens(theme.palette.mode);

	const isAdmin = useSelector(selectIsAdminUser)

	const [sortBy, setsortBy] = useState(null);
	const [dataFilter, setdataFilter] = useState([]);

	const [isLoadingTicket, setIsLoadingTicket] = useState({});


	const [sortDirection, setSortDirection] = useState("asc"); // or 'desc'


	const tablePrintRef = useRef(null);

	const inlineComputedStyles = (root) => {
		const all = root.querySelectorAll("*");
		all.forEach((el) => {
			const cs = window.getComputedStyle(el);
			// aplica o cssText com propriedades relevantes
			el.style.boxSizing = cs.boxSizing;
			el.style.backgroundColor = cs.backgroundColor;
			el.style.color = cs.color;
			el.style.border = cs.border;
			el.style.borderCollapse = cs.borderCollapse;
		});
	};

	const handlePrintRomaneios = async () => {
		const el = tablePrintRef.current;
		if (!el) return;

		el.classList.add(styles.romaneioTablePrintMode);
		el.classList.add(styles.printMode);
		// 1. Criar um container temporário para não afetar o layout original
		const container = document.createElement("div");
		container.style.position = "absolute";
		container.style.left = "0";
		container.style.top = "0";
		container.style.zIndex = "-1";
		container.style.width = el.offsetWidth + "px"; // Mantém a largura exata

		const clone = el.cloneNode(true);

		// Forçar fundo branco e remover transparências que confundem o canvas
		clone.style.backgroundColor = "#ffffff";
		clone.style.color = "#000000";

		container.appendChild(clone);
		document.body.appendChild(container);

		try {
			const canvas = await html2canvas(clone, {
				scale: 2,
				useCORS: true,
				allowTaint: true,
				backgroundColor: "#ffffff",
				// IMPORTANTE: Isso ajuda o html2canvas a focar no elemento certo
				logging: false,
				width: el.offsetWidth,
				height: el.offsetHeight,
			});

			const dataUrl = canvas.toDataURL("image/png");

			// ... (seu código de formatação de data permanece igual)
			const now = new Date();
			const formatted = now.toLocaleString("pt-BR", { /* ... */ }).replace(/\//g, "-").replace(/,?\s/g, "-").replace(/:/g, "-");

			const a = document.createElement("a");
			a.href = dataUrl;
			a.download = `romaneios-${formatted}.png`;
			a.click();
			el.classList.remove(styles.printMode);
			el.classList.remove(styles.romaneioTablePrintMode);
		} catch (err) {
			console.error("Erro ao gerar imagem:", err);
		} finally {
			// Limpar o DOM
			document.body.removeChild(container);
		}
	};



	// useEffect(() => {
	// 	setdataFilter(data);
	// 	let newObj = {}
	// 	data.forEach(element => {
	// 		if(newObj[element.fazendaOrigem]){
	// 			newObj[element.fazendaOrigem] += 1
	// 		} else {
	// 			newObj[element.fazendaOrigem] = 1
	// 		}
	// 	});
	// 	const newArr = Object.keys(newObj).map((data) => {
	// 		return ({farm: data, quant: newObj[data]})
	// 	})
	// 	console.log('new Arrr: ', newArr)
	// 	setResumeByFarm(newArr)
	// }, []);

	// useEffect(() => {
	// 	setdataFilter(data);
	// 	let newObj = {}
	// 	data.forEach(element => {
	// 		if(newObj[element.fazendaOrigem]){
	// 			newObj[element.fazendaOrigem] += 1
	// 		} else {
	// 			newObj[element.fazendaOrigem] = 1
	// 		}
	// 	});
	// 	const newArr = Object.keys(newObj).map((data) => {
	// 		return ({farm: data, quant: newObj[data]})
	// 	})
	// 	setResumeByFarm(newArr)
	// }, [data, setResumeByFarm]);

	const iconDict = [
		{ cultura: "Feijão", icon: beans, alt: "feijao" },
		{ cultura: "FEIJAO MUNGO", icon: beans, alt: "feijao" },
		{ cultura: "Arroz", icon: rice, alt: "arroz" },
		{ cultura: "Soja", icon: soy, alt: "soja" },
		{ cultura: "Algodão", icon: cotton, alt: "algodao" },
		{ cultura: "Milho", icon: corn, alt: "milho" }
	];

	const filteredIcon = (data) => {
		const filtered = iconDict.filter(
			(dictD) => dictD.cultura === data
		);

		if (filtered.length > 0) {
			return filtered[0].icon;
		}
		return question;
	};

	const filteredAlt = (data) => {
		const filtered = iconDict.filter(
			(dictD) => dictD.cultura === data
		);

		if (filtered.length > 0) {
			return filtered[0].alt;
		}
		return question;
	};

	useEffect(() => {
		let nextData = [...data];

		if (sortBy === "fazendaOrigem") {
			nextData.sort((a, b) => {
				const fazendaCompare = String(a?.fazendaOrigem || "").localeCompare(
					String(b?.fazendaOrigem || "")
				);

				if (fazendaCompare !== 0) {
					return fazendaCompare;
				}

				return Number(a?.ticket || 0) - Number(b?.ticket || 0);
			});
		}

		if (sortBy === "relatorioColheita") {
			nextData.sort((a, b) => {
				return Number(b?.relatorioColheita || 0) - Number(a?.relatorioColheita || 0);
			});
		}

		if (sortBy === "parcelas") {
			nextData.sort((a, b) => {
				const parcelaA = a.parcelasObjFiltered?.[0]?.parcela || "";
				const parcelaB = b.parcelasObjFiltered?.[0]?.parcela || "";

				if (!parcelaA && !parcelaB) return 0;
				if (!parcelaA) return 1;
				if (!parcelaB) return -1;

				const matchA = parcelaA.match(/^([A-Za-z]+)(\d+)$/);
				const matchB = parcelaB.match(/^([A-Za-z]+)(\d+)$/);

				if (!matchA || !matchB) return parcelaA.localeCompare(parcelaB);

				const [, prefixA, numberA] = matchA;
				const [, prefixB, numberB] = matchB;

				if (prefixA !== prefixB) {
					return prefixA.localeCompare(prefixB);
				}

				return parseInt(numberA) - parseInt(numberB);
			});
		}

		setdataFilter(nextData);
	}, [sortBy, data]);


	useEffect(() => {
		if (selected.length === 0) {
			setSortDirection(null)
			setsortBy(null)
		}
	}, [selected]);

	const formatWeight = (peso) => {
		if (peso > 0) {
			return Number(peso).toLocaleString("pt-BR") + " Kg";
		}
		return "-";
	};
	const formatPercent = (data) => {
		if (data > Number(0)) {
			return Number(data).toLocaleString("pt-br", {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}) + " %"
		}
		return "-";
	}

	const normalizeTicket = (value) => {
		if (value === null || value === undefined || value === "") return "-";
		return String(value).replace(/^0+/, "") || "0";
	};

	const getTicketDuplicateKey = (carga) => {
		const filial = String(carga?.filialPro || "").trim();

		const ticket = normalizeTicket(
			carga?.ticket || carga?.codTicketPro || "-"
		);

		return `${filial}::${ticket}`;
	};



	if (data.length === 0) {
		return (
			<Box justifyContent={"center"} alignItems={"center"}>
				<Typography variant="h1" color={"white"} onClick={() => setFilterDataArr(null)} sx={{ cursor: 'pointer' }}>
					Sem Romaneios Pendentes
				</Typography>
			</Box>
		);
	}

	const handleOrder = (data) => {
		setsortBy(data); // No need for a function here

		setSortDirection((prev) => {
			return prev === 'asc' ? 'desc' : 'asc';
		});
	};
	const handlerCopyData = (carga) => {
		navigator.clipboard.writeText(carga?.id)
		toast.success(`ID Copiado!!: ${carga.relatorioColheita} - ID: ${carga.id}`, {
			position: 'top-center',
		})
	}

	const handleRefreshTicket = async (e, carga) => {
		e?.stopPropagation?.();

		if (!carga?.id) return;

		setIsLoadingTicket((prev) => ({ ...prev, [carga.id]: true }));

		toast.loading(`Reenviando para o Protheus: ${carga.relatorioColheita} - ID: ${carga.id}`, {
			id: `resend-${carga.id}`,
			position: "top-center",
		});

		try {
			const response = await nodeServerSrd.post("resend-to-protheus/", {
				id: carga.id,
				headers: {
					Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
				},
			});

			const { status, data } = response;

			if ((status === 200 || status === 202) && data?.ok) {
				setdataFilter((prev) =>
					prev.map((item) =>
						item.id === carga.id
							? {
								...item,
								protheusSyncStatus: "processing",
								protheusLastError: "",
								protheusLastAttemptAt: new Date(),
							}
							: item
					)
				);

				toast.success(`Reenvio iniciado: ${carga.relatorioColheita}`, {
					id: `resend-${carga.id}`,
					position: "top-center",
				});

				return response;
			}

			toast.error(`Resposta inesperada ao reenviar: ${carga.relatorioColheita}`, {
				id: `resend-${carga.id}`,
				position: "top-center",
			});

			return response;
		} catch (error) {
			const message =
				error?.response?.data?.message ||
				error?.message ||
				"Problema ao iniciar o reenvio para o Protheus";

			toast.error(`${message}: ${carga.relatorioColheita} - ID: ${carga.id}`, {
				id: `resend-${carga.id}`,
				position: "top-center",
			});
		} finally {
			setIsLoadingTicket((prev) => ({ ...prev, [carga.id]: false }));
		}
	};



	return (
		<Box width={"100%"} height={"100%"}

		>
			<Box
				ref={tablePrintRef}
				width={"100%"}
			>

				<Table striped bordered hover style={{ color: colors.textColor[100], marginBottom: '20px' }} size="" className={styles.romaneioTable}>
					<colgroup>
						<col style={{ width: 160 }} /> {/* Data */}
						<col style={{ width: 90 }} />  {/* Romaneio */}
						<col style={{ width: 70 }} />  {/* Ticket */}
						<col style={{ width: 140 }} /> {/* Projeto */}
						<col style={{ width: 140 }} /> {/* Parcelas */}
						<col style={{ width: 60 }} />  {/* Cultura */}
						<col style={{ width: 140 }} /> {/* Variedade */}
						<col style={{ width: 60 }} />  {/* Obs */}
						<col style={{ width: 90 }} />  {/* Placa */}
						<col style={{ width: 160 }} /> {/* Motorista */}
						<col style={{ width: 110 }} /> {/* Destino */}
						<col style={{ width: 90 }} />  {/* Bruto */}
						<col style={{ width: 80 }} />  {/* Tara */}
						<col style={{ width: 90 }} />  {/* Líquido */}
						<col style={{ width: 80 }} />  {/* Umidade */}
						<col style={{ width: 90 }} />  {/* Impureza */}
						<col style={{ width: 170 }} /> {/* Saída */}
						<col style={{ width: 70 }} />  {/* Status */}
					</colgroup>
					<thead style={{ backgroundColor: colors.blueOrigin[400] }}>
						<tr>
							<th>Data</th>
							<th
								onClick={() => handleOrder("relatorioColheita")}
								style={{ cursor: "pointer" }}
							>
								Romaneio {sortBy === "relatorioColheita" && (sortDirection !== "asc" ? "🔼" : "🔽")}
							</th>
							<th>Ticket</th>
							<th
								onClick={() => handleOrder("fazendaOrigem")}
								style={{ cursor: "pointer" }}
							>
								Projeto {sortBy === "fazendaOrigem" && (sortDirection !== "asc" ? "🔼" : "🔽")}
							</th>
							<th onClick={() => handleOrder("parcelas")} style={{ cursor: "pointer" }}>
								Parcelas {sortBy === "parcelas" && (sortDirection !== "asc" ? "🔼" : "🔽")}
							</th>
							<th>Cultura</th>
							<th>Variedade</th>
							<th>Obs</th>
							<th>Placa</th>
							<th>Motorista</th>
							<th>Destino</th>
							<th>Bruto</th>
							<th>Tara</th>
							<th>Líquido</th>
							<th>Umidade</th>
							<th>Impureza</th>
							<th>Saída</th>
							<th>Status</th>
						</tr>
					</thead>
					<tbody>
						{dataFilter &&
							dataFilter.map((carga, i) => {
								const newDate = carga?.pesoBruto > 0 ? carga.entrada.toDate().toLocaleString("pt-BR") : carga.syncDate.toDate().toLocaleString("pt-BR");
								const getTicket = carga?.ticket ? carga.ticket : '-'
								const ticketDuplicateKey = getTicketDuplicateKey(carga);
								const isDuplicatedTicket = duplicates?.includes(ticketDuplicateKey);
								const getVariedade = carga?.parcelasObjFiltered ? carga?.parcelasObjFiltered?.map((data) => data.variedade) : []
								const filtVariedade = [...new Set(getVariedade)]?.join(' - ')
								const getParcelas = carga?.parcelasObjFiltered ? carga?.parcelasObjFiltered?.map((data) => data.parcela) : []
								// console.log("carga", carga)

								// 1. Tenta extrair as culturas das parcelas, removendo valores nulos/undefined
								const culturasDasParcelas = carga?.parcelasObjFiltered
									? carga.parcelasObjFiltered.map(p => p.cultura).filter(c => c)
									: [];

								// 2. Define getCultura: 
								// Se houver culturas na lista de parcelas, usa elas. 
								// Caso contrário, usa a cultura da raiz do objeto.
								const getCulturaHere = culturasDasParcelas.length > 0
									? culturasDasParcelas
									: (carga?.cultura || '-');

								// 3. O resultado final (para exibição simples)
								const getCultura = Array.isArray(getCulturaHere) ? getCulturaHere[0] : getCulturaHere;

								const hasTicketInfo = carga?.filialPro && carga?.codTicketPro;

								const isProcessingProtheus =
									carga?.protheusSyncStatus === "processing" || isLoadingTicket[carga.id];

								const wasAcceptedByProtheus =
									(carga?.protheusSyncStatus === "success" || !carga?.protheusSyncStatus) &&
									Number(carga?.protheusReceipt?.codigo) === 200 &&
									!!carga?.protheusReceipt?.cod_ticket;

								const shouldShowResendIcon =
									hasTicketInfo && !wasAcceptedByProtheus && !isProcessingProtheus;

								return (
									<tr
										key={i}
										className={`${i % 2 !== 0 ? styles.oddRow : styles.evenRow} ${theme.palette.mode === 'light' && i % 2 !== 0 && styles.oddRowLight}`}
										style={{ borderTop: carga?.firstOne && `0.5px solid ${colors.textColor[100]}` }}
									>
										<td>{newDate}</td>
										<td onClick={() => handlerCopyData(carga)} style={{ cursor: 'pointer' }}>{carga.relatorioColheita}</td>
										{
											isProcessingProtheus ? (
												<td>
													<Tooltip
														title="Envio ao Protheus em processamento"
														arrow
														slotProps={{
															tooltip: {
																sx: {
																	fontSize: "1.25rem",
																},
															},
														}}
													>
														<Box
															sx={{
																display: "flex",
																justifyContent: "center",
																alignItems: "center",
																minHeight: 24,
															}}
														>
															<CircularProgress size={16} color="inherit" />
														</Box>
													</Tooltip>
												</td>
											) : shouldShowResendIcon ? (
												<td>
													<Tooltip
														title={
															carga?.protheusLastError
																? `Erro Protheus: ${carga.protheusLastError}`
																: "Reenviar para o Protheus"
														}
														arrow
														slotProps={{
															tooltip: {
																sx: {
																	fontSize: "1.25rem",
																},
															},
														}}
													>
														<IconButton
															aria-label="reenviar para o protheus"
															size="sm"
															color="success"
															onClick={(e) => handleRefreshTicket(e, carga)}
															style={{ padding: "2px", justifyContent: "center" }}
															disabled={isLoadingTicket[carga.id] || false}
														>
															<PublishedWithChanges fontSize="inherit" />
														</IconButton>
													</Tooltip>
												</td>
											) : (
												<Tooltip
													title={
														wasAcceptedByProtheus
															? `Enviado ao Protheus | Ticket ${carga.protheusReceipt.cod_ticket}`
															: hasTicketInfo
																? "Clique para reenviar"
																: "Ticket"
													}
													arrow
													slotProps={{
														tooltip: {
															sx: {
																fontSize: "1.25rem",
															},
														},
													}}
												>
													<td
														onClick={(e) => {
															if (hasTicketInfo && !isProcessingProtheus) {
																handleRefreshTicket(e, carga);
															}
														}}
														style={{
															color: isDuplicatedTicket ? "red" : undefined,
															fontWeight: isDuplicatedTicket ? "bold" : undefined,
															cursor: hasTicketInfo ? "pointer" : "help",
														}}
													>
														{getTicket}
													</td>
												</Tooltip>
											)
										}
										<td>{carga.fazendaOrigem.replace('Projeto ', '')}</td>
										<td>
											{getParcelas
												.sort((a, b) => a.localeCompare(b))
												.join(", ")}
										</td>
										<td>
											{
												getCultura &&
												<img
													src={filteredIcon(
														getCultura
													)}
													alt={filteredAlt(
														getCultura
													)}
													style={{
														filter: "drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4))",
														width: '20px',
														height: '20px'
													}}
												/>
											}
										</td>
										<td>{filtVariedade}</td>
										<td>
											{carga.observacoes ? (
												<Tooltip title={carga.observacoes} arrow
													slotProps={{
														tooltip: {
															sx: {
																fontSize: '1.25rem', // Tamanho de fonte menor
															},
														},
													}}
												>
													<Box>
														<LightbulbOutlinedIcon color={'success'} />
													</Box>
												</Tooltip>
											) : (
												<Box>

												</Box>
											)}
										</td>
										<td style={{ color: duplicatesPlates?.includes(carga.placa) && 'red', fontWeight: duplicatesPlates?.includes(carga.placa) && 'bold' }}>
											{carga.placa.slice(0, 3)}-{carga.placa.slice(3, 12)}
										</td>
										<td style={{
											whiteSpace: 'nowrap',   // Força o nome a ficar em uma única linha
											overflow: 'visible',    // Garante que o texto todo apareça
											padding: '8px 16px'     // Espaçamento opcional para respiro
										}}>
											{carga.motorista}
										</td>
										<td>{carga.fazendaDestino}</td>
										<td>
											{carga.pesoBruto
												? formatWeight(carga.pesoBruto)
												: formatWeight(0)}
										</td>
										<td>
											{carga.tara ? formatWeight(carga.tara) : formatWeight(0)}
										</td>
										<td>
											{carga.liquido
												? formatWeight(carga.liquido)
												: formatWeight(0)}
										</td>
										<td>
											{carga?.umidade
												? formatPercent(carga?.umidade)
												: formatPercent(0)}
										</td>
										<td>
											{carga?.impureza
												? formatPercent(carga?.impureza)
												: formatPercent(0)}
										</td>
										<td>
											{carga?.saida
												? carga?.saida.toDate().toLocaleString("pt-BR")
												: "-"}
										</td>
										<td>
											{carga.saida ? (
												<IconButton
													aria-label="delete"
													size="sm"
													color={carga.saida ? "success" : "warning"}
													onClick={(e) => isAdmin && handleUpdateCarga(e, carga)}
													style={{ padding: "2px" }}
												>
													{
														isAdmin ?
															<DoneAll fontSize="inherit" />
															:
															<AgricultureIcon fontSize="small" color="warning" />
													}
												</IconButton>
											) : (
												<IconButton
													aria-label="delete"
													size="sm"
													color={"success"}
													onClick={(e) => handleRefreshTicket(e, carga)}
													style={{ padding: "2px", justifyContent: 'center' }}
													disabled={isProcessingProtheus || false}
												>
													{isProcessingProtheus ? (
														<CircularProgress size={16} color="inherit" />
													) : (
														<AgricultureIcon fontSize="small" color="warning" />
													)}
												</IconButton>
											)}
										</td>
									</tr>
								);
							})}
					</tbody>
				</Table>
			</Box>
			{dataFilter?.length > 0 && (
				<Box
					sx={{
						width: "100%",
						display: "flex",
						justifyContent: "flex-end",
						mt: 0.5,
					}}
				>
					<Tooltip title="Salvar print (PNG)" arrow>
						<span>
							<IconButton
								onClick={handlePrintRomaneios}
								color="info"
								size="large"
								sx={{
									borderRadius: "12px",
									backgroundColor: "rgba(255,255,255,0.06)",
									":hover": { backgroundColor: "rgba(255,255,255,0.12)" },
								}}
							>
								<PhotoCameraIcon />
							</IconButton>
						</span>
					</Tooltip>
				</Box>
			)}
		</Box>
	);
};

export default RomaneiosTable;
